module.exports = __webpack_public_path__ + "img/1F3F4-E0067-E0062-E0077-E006C-E0073-E007F.df9ccb2d.svg";